import styled from 'styled-components';

export const WheelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
